import request from "@/config/utils/request";

//查询是否登录调取supplierCode接口
export function getUserInfo(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/userInfo", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 点击立即注册用户接口
export function getReguser(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/reguser", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 发送验证码
export function getPlatform(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/sendVerCode", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data
  });
}

//校验验证码 + 校验手机号
export function getCheckContact(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/checkContact", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 校验公司名称(商家开店接口)
export function checkShopName(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/checkShopName", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//完善信息带出 天眼查查询企业信息
export function getCompany(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryInfoByName", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//完善信息 获取所在区域
export function getPmcAdress(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/qryByCode", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 保存供应商信息
export function getSaveSupplierInfo(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/saveSupplierInfo", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//完善信息+申请合作 上传附件接口
export function uploads(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/uploadFileToOss",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data
  });
}

// 完善信息 查询供应商信息
export function getQueryInfoByCode(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryInfoByCode", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//完善信息 查询供应商所属集团
export function getQueryUnInfoByName(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryUnInfoByName", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//开店保存完善信息
export function getSaveShopSupplierInfo(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/saveShopSupplierInfo", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
//申请合作 根据合作单位名字获取单位id
export function getIdByName(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/byName", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//申请合作 查询供应商类型
export function getSupplierType(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/supplierClassly", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//查询需要上传什么资质文件
export function getQryAptitudeBySupplierType(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/qryAptitudeBySupplierType", // 后端接口
    method: "post",
    data
  });
}

//申请合作 添加服务范围接口
export function getQryMatSubCatalog(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/qryMatSubCatalog", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//申请合作意向提交
export function getSubmitCoopUnit(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/submitCoopUnit", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//查询合作单位信息
export function getQueryCoopUnit(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryCoopUnit", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 查询公司类型
export function getQryDictByCode(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/qryDictByCode", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 查询店铺信息
export function getQueryShopInfo(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryShopInfo", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 申请开店提交
export function getSubmitShop(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/submitShop", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 校验店铺名称是否可用
export function getCheckShopName(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/checkShopName", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
//申请合作-名称查询信息
export function queryInfoBySupName(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryInfoBySupName", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
//查询审批中详情
export function queryInfoCheckDetail(data) {
  return request({
    url: "/apis/hwsp/reg/users/signup/queryInfoCheckDetail", // 后端接口
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
